import { useParams } from "react-router-dom";

import { Box, useTheme, useMediaQuery } from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";

import { useMSALPayload } from "@initia-digital/auth-client-utils";
import { FilledButton, Typography } from "@initia-digital/component-library";
import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";

import { EditPlanSummary } from "./EditPlanSummary";
import { IPlanStageProps } from "../interfaces/componentInterfaces";
import { PlanActions } from "./PlanActions";
import { SectionHeader } from "./SectionHeader";
import { useWorkAndSafetyStore } from "../store";
import { ActionAPlanButton } from "./Buttons";
import { useIsAdmin } from "../hooks";
import { PlanHeader } from "./PlanHeader";

export const ActionAPlan = (props: IPlanStageProps) => {
    // --------------------------------
    const { handleSave, handleStatusChange } = props;

    const { editPlanState } = useWorkAndSafetyStore();
    const { title, status } = editPlanState;

    const authDetail = useMSALPayload();
    const isAdmin = useIsAdmin(authDetail, true);

    const theme = useTheme();
    const isSmallerThanSm = useMediaQuery(theme.breakpoints.down('sm'));

    const params = useParams();
    const { planId } = params;
    const isCreate = !baseDefinedAndNotNullNarrowing(planId);


    return (
        <Box
            sx={{ 
                width: '100%',
                containerType: 'inline-size'
            }}
        >
        <PlanHeader
            id={planId}
            title={title}
            status={status}
        />
        <Box 
                display="flex" flexDirection={isSmallerThanSm ? "column" : "row"} flexWrap="wrap"
                alignItems="center" justifyContent="space-between"
                maxWidth="100%"
            >
                <SectionHeader label="Action your plan" />
                <PlanActions
                    handleSave={handleSave}
                    handleStatusChange={handleStatusChange}
                />
            </Box>
            <Box>
                <Box my={ isSmallerThanSm ? "20px" : "0px" }>
                    <Typography
                        fontSize={"0.9rem"}
                        fontWeight={700}
                        color={theme.palette.primary.contrastText}
                    >
                        Here's a summary of the plan
                    </Typography>
                </Box>
                <Box
                    mt="10px"
                >
                    <EditPlanSummary />
                </Box>
            </Box>
            <Box
                display="flex" flexDirection="row" justifyContent="center" flexWrap="wrap"
                mt="30px"
            >
                <Box p="3px">
                    <FilledButton
                        size="large"
                        onClick={() => handleSave(editPlanState)}
                        startIcon={<SaveIcon />}
                    >
                        Save
                    </FilledButton>
                </Box>
                {
                    !isCreate && (
                        <Box p="3px">
                            <ActionAPlanButton
                                size="large"
                                planId={planId}
                                handleStatusChange={
                                    baseDefinedAndNotNullNarrowing(handleStatusChange) ?
                                    handleStatusChange :
                                    () => console.error(`Handle status change for ${status} not provided`)}
                                status={status} isAdmin={isAdmin}
                            />
                        </Box>
                    )
                }
            </Box>
        </Box>
    );
};